/**
 *  the feedback section (content) and tabs are directly using the old component and tweaked the css as no big changes in design for them
 */
import { Color } from '@bb/elements-web';
import React, { useContext, useState } from 'react';
import styled from 'styled-components';

import { ListingMapView, TabPane, Tabs } from 'components';
import {
  AccessDetailsInfo,
  FeedbackSection,
  HistorySection,
  LogsSection,
} from '../components';
import AgentOrgSection from '../componentsV2/AgentOrgSection';
import Header from '../componentsV2/Header';
import ShowingInformationRow from '../componentsV2/ShowingInformationRow';
import TourSection from '../componentsV2/TourSection';
import { BODY_MARGIN_LEFT, BORDER_RADIUS } from '../constants';
import ShowingDetailsContext from './ShowingDetailsContext';

// ShowingDetailsV2 only used for coop in internal dashboard
const ShowingDetailsLayout: React.FC = () => {
  const {
    appointment,
    auth,
    feedbackConfig,
    feedbackRef,
    fromTourPage,
    listing,
    listingAppointmentConfig,
    lockboxPhoto,
    showFeedback,
    userType,
    fetchAppointment,
    fetchFeedback,
    setFeedbackConfig,
  } = useContext(ShowingDetailsContext);
  const [currentTab, setCurrentTab] = useState<'details' | 'history' | 'logs'>(
    'details',
  );

  const isListingRep = listing.repsObjectIds.includes(auth?.id);

  const handleTabChange = (key: string) => {
    setCurrentTab(key as typeof currentTab);
  };

  const getDetailsSection = () => (
    <>
      <TourSection />
      <StyledWrapper data-cy="accessInfo-wrapper">
        <AccessDetailsInfo
          appointment={appointment}
          lockboxPhoto={lockboxPhoto}
        />
      </StyledWrapper>
      <AgentOrgSection />
      {showFeedback && (
        <div ref={feedbackRef}>
          <FeedbackSection
            auth={auth}
            userType={userType}
            appointment={appointment}
            feedbackConfig={feedbackConfig!}
            fetchFeedback={fetchFeedback}
            fetchAppointment={fetchAppointment}
            setFeedbackConfig={setFeedbackConfig}
          />
        </div>
      )}
    </>
  );
  const displayTabsOrNot = () => {
    if (!isListingRep) {
      return getDetailsSection();
    }
    return (
      <StyledTabs
        activeKey={currentTab}
        data-cy="showing-details-tab"
        onChange={handleTabChange}
      >
        <StyledTabPane tab="Details" key="details">
          {getDetailsSection()}
        </StyledTabPane>
        <StyledTabPane tab="History" key="history">
          <HistorySection
            appointment={appointment}
            listingAppointmentConfig={listingAppointmentConfig}
            timezone={listing.timezone}
          />
        </StyledTabPane>
        <StyledTabPane tab="Logs" key="logs">
          <LogsSection appointment={appointment} timezone={listing.timezone} />
        </StyledTabPane>
      </StyledTabs>
    );
  };
  return (
    <Layout fromTourPage={fromTourPage}>
      <Header />
      <ShowingInformationRow />
      <ListingMapView
        coordinates={listing.coords?.coordinates as [number, number]}
      />
      {displayTabsOrNot()}
    </Layout>
  );
};

export default ShowingDetailsLayout;

const Layout = styled.div<{ fromTourPage: boolean }>`
  min-height: calc(100vh - 90px);
  width: 90%;
  display: flex;
  flex-flow: column nowrap;
  margin: auto;
  margin-bottom: 50px;
  padding: 20px;
  ${({ fromTourPage }) => fromTourPage && 'padding:20px 0px; min-height:auto;'}
  background: white;
  & > [data-cy='tour-map-container'] > div {
    border-radius: ${BORDER_RADIUS}px;
  }
`;
const StyledWrapper = styled.div`
  #detail-row-body-old {
    margin-left: ${BODY_MARGIN_LEFT}px;
    color: ${Color.BLACK};
    [data-cy='lockbox-photo-button'] {
      color: ${Color.PRIMARY};
      &:hover {
        color: ${Color.HOVER_PRIMARY};
      }
    }
  }
`;
const StyledTabs = styled(Tabs)`
  .ant-tabs-nav {
    margin: 0;
  }
  .ant-tabs-tab-active .ant-tabs-tab-btn,
  .ant-tabs-ink-bar {
    color: ${Color.PRIMARY};
  }
  .ant-tabs-tab-btn:hover {
    color: ${Color.HOVER_PRIMARY};
  }
`;
const StyledTabPane = styled(TabPane)`
  height: 100%;
`;
